var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "m10.741 1.486.414.773c.28.523.419.784.327.896-.093.112-.397.022-1.006-.16a6.754 6.754 0 0 0-1.925-.277c-3.628 0-6.57 2.854-6.57 6.375 0 1.162.32 2.25.88 3.188m3.5 4.42-.413-.773c-.28-.523-.42-.784-.327-.896.092-.112.397-.022 1.006.159a6.77 6.77 0 0 0 1.924.278c3.629 0 6.57-2.854 6.57-6.376 0-1.16-.32-2.25-.879-3.187"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M0 0h16.597v16.597H0z",
    transform: "translate(.253 .795)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.97484645.svg";
export { ForwardRef as ReactComponent };